import { Routes, Route } from 'react-router-dom';
import Home from '../features/home/components/Home';
import Terminal from '../features/terminal/components/Terminal';
import Mail from '../features/mail/components/Mail';
import Docker from '../features/docker/components/Docker';
import Navbar from '../shared/components/Navbar';
import { UptimeBadge } from '../shared/components/UptimeBadge';

export function AppRouter() {
  return (
    <div>
      <UptimeBadge />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terminal" element={<Terminal />} />
        <Route path="/docker" element={<Docker />} />
        <Route path="/mail" element={<Mail />} />
      </Routes>
      <Navbar />
    </div>
  );
}
